import useLoyaltyEnabled from './useLoyaltyEnabled'
import useLoyaltyKilled from './useLoyaltyKilled'
import { useLoyaltyMembershipStorage } from './useLoyaltyMembershipStorage'

/**
 * Resolved gate for "should loyalty UI render for this visitor?"
 *
 * Combines three signals:
 *   - per-customer enrollment cache populated by useLoyaltyAutoEnroll
 *     (true iff loyalty-service confirmed isLoyaltyMember for the
 *     currently signed-in customer — handles cross-device sign-in on
 *     a control-bucket device)
 *   - f98 rollout bucket (covers guests with no customerId and pre-
 *     bootstrap signed-in users in the loyalty bucket so the aspirational
 *     "create an account & earn" banner still renders)
 *   - f107 global kill switch (rollback lever — flip on to hide all
 *     loyalty UI everywhere even for enrolled customers)
 *
 * Downstream surfaces still AND in their own audience filter
 * (isCustomerSignedIn / !isCustomerSignedIn) so signed-in banners don't
 * leak into guest views or vice versa.
 */
const useIsLoyaltyActiveForCustomer = (): boolean => {
  const killed = useLoyaltyKilled()
  const { loyaltyMembershipRecord } = useLoyaltyMembershipStorage()
  const isLoyaltyBucket = useLoyaltyEnabled()
  if (killed) return false
  return Boolean(loyaltyMembershipRecord?.isLoyaltyMember) || isLoyaltyBucket
}

export default useIsLoyaltyActiveForCustomer
